/* src/app/_shared/components/audio-transcriber/audio-transcriber.component.scss */
:host {
  --icon-size: 22px;
  --icon-color: white;
  --button-background-color: #B8BBC2;
  --button-size: 15px;
  --voice-animation-bg-color: white;
  --voice-animation-border-color: #EAEAEA;
  --voice-animation-shadow-color: rgba(110, 94, 224, 0.20);
  --voice-animation-border-radius: 20px;
  --voice-animation-width: 80px;
  --voice-animation-height: 30px;
  --wave-animation-duration: 1s;
  --wave-animation-timing: ease-in-out;
  --wave-animation-infinite: infinite;
  --wave-animation-delay-increment: 0.15s;
}
.container {
  display: flex;
  flex-direction: row;
  gap: 6.5px;
}
.container .record-button {
  cursor: pointer;
  background-color: var(--button-background-color);
  padding: 10px;
  width: var(--button-size);
  height: var(--button-size);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}
.container .record-button > flw-icon {
  --cursor: pointer;
  --size: var(--icon-size);
  --color: var(--icon-color);
}
.container.recording > .record-button {
  background-color: var(--primary-color);
}
.va-left {
  flex-direction: row-reverse;
}
.va-top {
  flex-direction: column-reverse;
}
.va-bottom {
  flex-direction: column;
}
.disabled {
  background-color: gray !important;
}
.voice-animation {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: 0 4px;
  width: var(--voice-animation-width);
  height: var(--voice-animation-height);
  background-color: var(--voice-animation-bg-color);
  border-radius: var(--voice-animation-border-radius);
  border: 0.25px solid var(--voice-animation-border-color);
  box-shadow: 0px 1px 3.7px 0px var(--voice-animation-shadow-color);
}
.voice-animation > div {
  width: 4px;
  border-radius: 6.5px;
  background: var(--secondary-color);
  animation: wave var(--wave-animation-duration) var(--wave-animation-timing) var(--wave-animation-infinite);
}
.voice-animation > div:nth-child(5) {
  animation-delay: 0s;
  height: 12px;
}
.voice-animation > div:nth-child(4),
.voice-animation > div:nth-child(6) {
  animation-delay: var(--wave-animation-delay-increment);
  height: 10px;
}
.voice-animation > div:nth-child(3),
.voice-animation > div:nth-child(7) {
  animation-delay: calc(var(--wave-animation-delay-increment) * 3);
  height: 8px;
}
.voice-animation > div:nth-child(2),
.voice-animation > div:nth-child(8) {
  animation-delay: calc(var(--wave-animation-delay-increment) * 2);
  height: 6px;
}
.voice-animation > div:nth-child(1),
.voice-animation > div:nth-child(9) {
  animation-delay: calc(var(--wave-animation-delay-increment) * 4);
  height: 4px;
}
@keyframes wave {
  0%, 100% {
    height: 4px;
  }
  12.5% {
    height: 8px;
  }
  25% {
    height: 12px;
  }
  37.5% {
    height: 16px;
  }
  50% {
    height: 20px;
  }
  62.5% {
    height: 16px;
  }
  75% {
    height: 12px;
  }
  87.5% {
    height: 8px;
  }
}
/*# sourceMappingURL=audio-transcriber.component-27ZFJYTL.css.map */
